const payRoutes = {
  path: "/pay",
  name: "Payment",
  component: () => import("@/viewsPay/Layout.vue"),
  children: [
    {
      path: "home",
      component: () => import("@/viewsPay/home/index.vue"),
    },
    {
      path: "product-info",
      component: () => import("@/viewsPay/product-info.vue"),
    },
    {
      path: "payment",
      component: () => import("@/viewsPay/payment.vue"),
    },
    {
      path: "order",
      component: () => import("@/viewsPay/order/order.vue"),
    },
    {
      path: "orderList",
      name: 'PayOrderList',
      component: () => import("@/viewsPay/order/orderList.vue"),
    },
    {
      path: 'mine',
      component: () => import("@/viewsPay/mine/index.vue"),
    }
  ],
};

export default payRoutes;
